import { ca } from '@cian/analytics';
import { EPageBlock, IBankPromoBlockPageExtra } from '../../../types/analytics';
import { IBank } from '../../../types/promosPage';
import { IPage } from '../../../types/redux';

type TAction = 'show_sopr' | 'Click';

interface ITrackBank {
  action: TAction;
  position: number;
  bank: IBank;
  page: IPage;
}

export function trackBank({ action, position, bank, page }: ITrackBank) {
  const pageExtra: IBankPromoBlockPageExtra = {
    block: EPageBlock.BankPromo,
    bank_id: bank.id,
    position,
  };

  return ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action,
    label: 'Block',
    page: {
      ...page,
      extra: pageExtra,
    },
  });
}
